// extracted by mini-css-extract-plugin
module.exports = {"z-index-modal":"1040","z-index-cleverfeed-sidebar":"10"};